import React from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap'

const LoginPromptModal = ({isOpen, toggle, onLogin, onDownloadAndLogin, onPurchase, items, isLoggedIn = false}) => {
    const hasItems = Array.isArray(items) && items.length > 0
    
    const handlePurchase = () => {
        console.log('[LoginPromptModal] Purchase button clicked')
        if (onPurchase) {
            onPurchase()
        }
        toggle()
    }
    
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered className="LoginPromptModal">
            <ModalHeader toggle={toggle} className="LoginPromptModal-header">
                Free uses exhausted
            </ModalHeader>
            <ModalBody className="LoginPromptModal-body">
                <div className="LoginPromptModal-content">
                    <p className="LoginPromptModal-text">
                        {isLoggedIn 
                            ? "You have no remaining image generations. Please purchase a package to continue."
                            : "You have used up all free image generations. Please log in to purchase more"
                        }
                    </p>
                    {hasItems && !isLoggedIn && (
                        <div className="LoginPromptModal-warning">
                            <p className="LoginPromptModal-warning-text">
                                Remember to download your generated images before logging in to avoid losing them.
                            </p>
                        </div>
                    )}
                </div>
            </ModalBody>
            <ModalFooter className="LoginPromptModal-footer">
                {isLoggedIn ? (
                    <Button 
                        color="primary" 
                        onClick={toggle}
                        className="LoginPromptModal-button-purchase"
                    >
                        OK
                    </Button>
                ) : (
                    <>
                        <Button 
                            color="secondary" 
                            outline 
                            onClick={toggle}
                            className="LoginPromptModal-button-cancel"
                        >
                            Cancel
                        </Button>
                        {hasItems && (
                            <Button 
                                color="primary" 
                                onClick={onDownloadAndLogin}
                                className="LoginPromptModal-button-download"
                            >
                                Download & Login
                            </Button>
                        )}
                        <Button 
                            color="primary" 
                            onClick={onLogin}
                            className="LoginPromptModal-button-login"
                        >
                            Login
                        </Button>
                    </>
                )}
            </ModalFooter>
        </Modal>
    )
}

export default LoginPromptModal

